import register from '@kpsys/angularjs-register';

import {InventoryDataService} from './inventory.data-service';
import {inventoryRoutes} from './inventory.routes';
import {ObservableCaptureDataService} from './observable-capture.data-service';
import { InventoriesController } from './inventories-page/inventories.controller';
import {InventoryPresenter} from './inventory.presenter';
import {MatchesController} from './matches-page/matches.controller';
import {CapturesController} from './captures-page/captures.controller';
import {MatchDataService} from './match.data-service';
import {MatchPresenter} from './match.presenter';

/**
 * @ngdoc module
 * @name portaro.features.inventory
 * @module portaro.features.inventory
 */

export default register('portaro.features.inventory')
    .config(inventoryRoutes)
    .service(InventoryDataService.serviceName, InventoryDataService)
    .service(ObservableCaptureDataService.serviceName, ObservableCaptureDataService)
    .service(MatchDataService.serviceName, MatchDataService)
    .service(InventoryPresenter.presenterName, InventoryPresenter)
    .service(MatchPresenter.presenterName, MatchPresenter)
    .controller(InventoriesController.controllerName, InventoriesController)
    .controller(MatchesController.controllerName, MatchesController)
    .controller(CapturesController.controllerName, CapturesController)
    .name();
